import { AssetStatusToUI } from '@y42/feature';
import { JobStatusToIcon } from '@y42/job';
import {
  AllowedDataLineageFilterOption,
  DataLineageDependencyType,
  DataLineageFilterType,
  DataLineageLinkType,
  DataLineageNodeTypes,
  DataLineageSelectedFilter,
  JobStatus,
  Y42AssetStatus,
} from '@y42/json-schema';
import { DataLineageAppliedFilterAvatar, DataLineageFilterOption } from './data-lineage-filter.model';
import { DataLineageNodeTypeToLogo } from './data-lineage.utils';

export const DataLineageDependencyFilterOptions: Record<DataLineageDependencyType, DataLineageFilterOption> = {
  [DataLineageDependencyType.Upstream]: {
    displayName: DataLineageDependencyType.Upstream,
    value: DataLineageDependencyType.Upstream,
    icon: 'arrow-left',
  },
  [DataLineageDependencyType.Downstream]: {
    displayName: DataLineageDependencyType.Downstream,
    value: DataLineageDependencyType.Downstream,
    icon: 'arrow-right',
  },
  [DataLineageDependencyType.All]: {
    displayName: DataLineageDependencyType.All,
    value: DataLineageDependencyType.All,
    icon: 'arrows-left-right',
  },
};

export const DataLineageLinkFilterOptions: Record<DataLineageLinkType, DataLineageFilterOption> = {
  [DataLineageLinkType.Connected]: {
    displayName: 'Connected',
    value: DataLineageLinkType.Connected,
    icon: 'link',
  },
  [DataLineageLinkType.Unconnected]: {
    displayName: 'Un-Connected',
    value: DataLineageLinkType.Unconnected,
    icon: 'link-slash',
  },
};

export const DataLineageModuleFilterOptions: Record<DataLineageNodeTypes, DataLineageFilterOption> = {
  [DataLineageNodeTypes.Integration]: {
    displayName: 'Integrations',
    value: DataLineageNodeTypes.Integration,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.Integration],
  },
  [DataLineageNodeTypes.UiModel]: {
    displayName: 'UI Models',
    value: DataLineageNodeTypes.UiModel,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.UiModel],
  },
  [DataLineageNodeTypes.SqlModel]: {
    displayName: 'SQL Models',
    value: DataLineageNodeTypes.SqlModel,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.SqlModel],
  },
  [DataLineageNodeTypes.Dashboard]: {
    displayName: 'Dashboards',
    value: DataLineageNodeTypes.Dashboard,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.Dashboard],
  },
  [DataLineageNodeTypes.DashboardTab]: {
    displayName: 'Dashboard Tabs',
    value: DataLineageNodeTypes.DashboardTab,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.DashboardTab],
  },
  [DataLineageNodeTypes.Widget]: {
    displayName: 'Widgets',
    value: DataLineageNodeTypes.Widget,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.Widget],
  },
  [DataLineageNodeTypes.Export]: {
    displayName: 'Exports',
    value: DataLineageNodeTypes.Export,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.Export],
  },
  [DataLineageNodeTypes.Empty]: {
    displayName: 'Empty',
    value: DataLineageNodeTypes.Empty,
    logo: DataLineageNodeTypeToLogo[DataLineageNodeTypes.Empty],
  },
};

export const DataLineageLatestJobStatusFilterOptions: Record<JobStatus, DataLineageFilterOption> = {
  [JobStatus.New]: {
    displayName: JobStatusToIcon[JobStatus.New].label,
    value: JobStatus.New,
    logo: JobStatusToIcon[JobStatus.New].icon,
  },
  [JobStatus.Ready]: {
    displayName: JobStatusToIcon[JobStatus.Ready].label,
    value: JobStatus.Ready,
    logo: JobStatusToIcon[JobStatus.Ready].icon,
  },
  [JobStatus.PartiallyReady]: {
    displayName: JobStatusToIcon[JobStatus.PartiallyReady].label,
    value: JobStatus.PartiallyReady,
    logo: JobStatusToIcon[JobStatus.PartiallyReady].icon,
  },
  [JobStatus.Invalid]: {
    displayName: JobStatusToIcon[JobStatus.Invalid].label,
    value: JobStatus.Invalid,
    logo: JobStatusToIcon[JobStatus.Invalid].icon,
  },
  [JobStatus.InvalidPartial]: {
    displayName: JobStatusToIcon[JobStatus.InvalidPartial].label,
    value: JobStatus.InvalidPartial,
    logo: JobStatusToIcon[JobStatus.InvalidPartial].icon,
  },
  [JobStatus.Pending]: {
    displayName: JobStatusToIcon[JobStatus.Pending].label,
    value: JobStatus.Pending,
    logo: JobStatusToIcon[JobStatus.Pending].icon,
  },
  [JobStatus.PartiallyEmpty]: {
    displayName: JobStatusToIcon[JobStatus.PartiallyEmpty].label,
    value: JobStatus.PartiallyEmpty,
    logo: JobStatusToIcon[JobStatus.PartiallyEmpty].icon,
  },
  [JobStatus.Canceled]: {
    displayName: JobStatusToIcon[JobStatus.Canceled].label,
    value: JobStatus.Canceled,
    logo: JobStatusToIcon[JobStatus.Canceled].icon,
  },
  [JobStatus.Expired]: {
    displayName: JobStatusToIcon[JobStatus.Expired].label,
    value: JobStatus.Expired,
    logo: JobStatusToIcon[JobStatus.Expired].icon,
  },
  [JobStatus.Queued]: {
    displayName: JobStatusToIcon[JobStatus.Queued].label,
    value: JobStatus.Queued,
    logo: JobStatusToIcon[JobStatus.Queued].icon,
  },
};

export const DataLineageAssetStatusFilterOptions: Record<Y42AssetStatus, DataLineageFilterOption> = {
  [Y42AssetStatus.Deprecated]: {
    displayName: AssetStatusToUI[Y42AssetStatus.Deprecated].label,
    value: Y42AssetStatus.Deprecated,
    logo: AssetStatusToUI[Y42AssetStatus.Deprecated].logo,
  },
  [Y42AssetStatus.Draft]: {
    displayName: AssetStatusToUI[Y42AssetStatus.Draft].label,
    value: Y42AssetStatus.Draft,
    logo: AssetStatusToUI[Y42AssetStatus.Draft].logo,
  },
  [Y42AssetStatus.Issue]: {
    displayName: AssetStatusToUI[Y42AssetStatus.Issue].label,
    value: Y42AssetStatus.Issue,
    logo: AssetStatusToUI[Y42AssetStatus.Issue].logo,
  },
  [Y42AssetStatus.NoStatus]: {
    displayName: AssetStatusToUI[Y42AssetStatus.NoStatus].label,
    value: Y42AssetStatus.NoStatus,
    logo: AssetStatusToUI[Y42AssetStatus.NoStatus].logo,
  },
  [Y42AssetStatus.Verified]: {
    displayName: AssetStatusToUI[Y42AssetStatus.Verified].label,
    value: Y42AssetStatus.Verified,
    logo: AssetStatusToUI[Y42AssetStatus.Verified].logo,
  },
};

export const SelectedFilterToFilterOption: Record<AllowedDataLineageFilterOption, DataLineageFilterOption> = {
  [DataLineageNodeTypes.Integration]: DataLineageModuleFilterOptions[DataLineageNodeTypes.Integration],
  [DataLineageNodeTypes.UiModel]: DataLineageModuleFilterOptions[DataLineageNodeTypes.UiModel],
  [DataLineageNodeTypes.SqlModel]: DataLineageModuleFilterOptions[DataLineageNodeTypes.SqlModel],
  [DataLineageNodeTypes.Dashboard]: DataLineageModuleFilterOptions[DataLineageNodeTypes.Dashboard],
  [DataLineageNodeTypes.DashboardTab]: DataLineageModuleFilterOptions[DataLineageNodeTypes.DashboardTab],
  [DataLineageNodeTypes.Widget]: DataLineageModuleFilterOptions[DataLineageNodeTypes.Widget],
  [DataLineageNodeTypes.Export]: DataLineageModuleFilterOptions[DataLineageNodeTypes.Export],
  [DataLineageNodeTypes.Empty]: DataLineageModuleFilterOptions[DataLineageNodeTypes.Empty],
  [DataLineageLinkType.Connected]: DataLineageLinkFilterOptions[DataLineageLinkType.Connected],
  [DataLineageLinkType.Unconnected]: DataLineageLinkFilterOptions[DataLineageLinkType.Unconnected],
  [DataLineageDependencyType.All]: DataLineageDependencyFilterOptions[DataLineageDependencyType.All],
  [DataLineageDependencyType.Downstream]: DataLineageDependencyFilterOptions[DataLineageDependencyType.Downstream],
  [DataLineageDependencyType.Upstream]: DataLineageDependencyFilterOptions[DataLineageDependencyType.Upstream],
  [JobStatus.New]: DataLineageLatestJobStatusFilterOptions[JobStatus.New],
  [JobStatus.Ready]: DataLineageLatestJobStatusFilterOptions[JobStatus.Ready],
  [JobStatus.PartiallyReady]: DataLineageLatestJobStatusFilterOptions[JobStatus.PartiallyReady],
  [JobStatus.Invalid]: DataLineageLatestJobStatusFilterOptions[JobStatus.Invalid],
  [JobStatus.InvalidPartial]: DataLineageLatestJobStatusFilterOptions[JobStatus.InvalidPartial],
  [JobStatus.Pending]: DataLineageLatestJobStatusFilterOptions[JobStatus.Pending],
  [JobStatus.PartiallyEmpty]: DataLineageLatestJobStatusFilterOptions[JobStatus.PartiallyEmpty],
  [JobStatus.Canceled]: DataLineageLatestJobStatusFilterOptions[JobStatus.Canceled],
  [JobStatus.Expired]: DataLineageLatestJobStatusFilterOptions[JobStatus.Expired],
  [JobStatus.Queued]: DataLineageLatestJobStatusFilterOptions[JobStatus.Queued],
  [Y42AssetStatus.Deprecated]: DataLineageAssetStatusFilterOptions[Y42AssetStatus.Deprecated],
  [Y42AssetStatus.Draft]: DataLineageAssetStatusFilterOptions[Y42AssetStatus.Draft],
  [Y42AssetStatus.Issue]: DataLineageAssetStatusFilterOptions[Y42AssetStatus.Issue],
  [Y42AssetStatus.NoStatus]: DataLineageAssetStatusFilterOptions[Y42AssetStatus.NoStatus],
  [Y42AssetStatus.Verified]: DataLineageAssetStatusFilterOptions[Y42AssetStatus.Verified],
};

export const getAppliedFilterAvatar = (filter: DataLineageSelectedFilter): DataLineageAppliedFilterAvatar => {
  if (filter.type === DataLineageFilterType.Tag) {
    return {
      icon: 'tag',
    };
  }

  return {
    icon: SelectedFilterToFilterOption[filter.value].icon,
    logo: SelectedFilterToFilterOption[filter.value].logo,
  };
};
